import React, { ReactNode } from 'react';

import { classNames } from '@/helpers/classNames';
import { Fade } from '@material-ui/core';

import styles from './AsaphDialogHeader.module.scss';

interface BaseHeaderComponentProps {
	needsFadeIn: boolean;
	fadeTimeout: number;
}

interface HeaderTitleProps extends BaseHeaderComponentProps {
	label?: ReactNode;
	component?: ReactNode;
}

interface HeaderButtonComponentProps extends BaseHeaderComponentProps {
	component: ReactNode;
}

interface AsaphDialogHeaderProps {
	leadingButton?: HeaderButtonComponentProps;
	title: HeaderTitleProps;
	trailingButton?: HeaderButtonComponentProps;
	className?: string;
}

export const AsaphDialogHeader = ({
	leadingButton,
	title,
	trailingButton,
	className,
}: AsaphDialogHeaderProps) => {
	return (
		<div className={classNames([styles['dialog-header'], className])}>
			{leadingButton && (
				<div className={styles['leading']}>
					<Fade
						in={leadingButton.needsFadeIn}
						timeout={leadingButton.fadeTimeout}
					>
						<div>{leadingButton.component}</div>
					</Fade>
				</div>
			)}
			<Fade in={title.needsFadeIn} timeout={title.fadeTimeout}>
				<div className={styles['title']}>
					{title.component ? title.component : title.label}
				</div>
			</Fade>
			{trailingButton && (
				<div className={styles['trailing']}>
					<Fade
						in={trailingButton.needsFadeIn}
						timeout={trailingButton.fadeTimeout}
					>
						<div>{trailingButton.component}</div>
					</Fade>
				</div>
			)}
		</div>
	);
};
